var _dec, _class;

/** @module others/renderSortMenu */

/* global rmlOpts */
import React from "react";
import { Menu, message } from "react-aiot";
import { i18n, IS_DARKMODE, hooks, textDots, getMediaDialogNextZIndex } from "../util";
import { observer, inject, Provider } from "mobx-react";
import { DashIcon, Modal } from "../components";
import FolderBox, { FolderBoxHeader } from "../components/FolderBox";
import { FolderSelector } from "../components/FolderSelector";
import { BasicStore, createUnorganizedNode } from "../store";
import { getSnapshot } from "mobx-state-tree";
import $ from "jquery";
const {
  Item,
  SubMenu,
  Divider,
  ItemGroup
} = Menu;

if (process.env.PLUGIN_CTX === "pro") {
  /* onlypro:start */
  hooks.register("folder/children/order/name_asc", (children, setChildren) => {
    setChildren(children.sort((a, b) => a.title.localeCompare(b.title)));
  }).register("folder/children/order/name_desc", (children, setChildren) => {
    setChildren(children.sort((a, b) => a.title.localeCompare(b.title) * -1));
  }).register("folder/children/order/id_asc folder/children/order/original", (children, setChildren) => {
    setChildren(children.sort((a, b) => a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
  }).register("folder/children/order/id_desc", (children, setChildren) => {
    setChildren(children.sort((a, b) => a.id > b.id ? -1 : b.id > a.id ? 1 : 0));
  });
  /* onlypro:end */
}
/**
 * An element rendering sortables for the popup menu.
 *
 * @returns React.Element[]
 */


const createSortables = (sortables, select, selectText) => Object.keys(sortables).map(key => /*#__PURE__*/React.createElement(Item, {
  key: key
}, sortables[key], " ", select === key && /*#__PURE__*/React.createElement("strong", null, "(", selectText, ")")));
/**
 * Apply an order to a tree node object.
 *
 * @this AppTree
 */


async function applyOrder(selected, key, automatically) {
  if (!rmlOpts.others.isPro && rmlOpts.others.showProHints) {
    this.setState({
      showProFeature: "order-subfolders"
    });
  } else {
    const hide = message.loading(i18n("sortLoadingText", {
      name: selected.title
    }));
    await selected.applyChildrenOrder(key, automatically);
    hide();
  }
}
/**
 * When clicking on a menu item in the order menu popup.
 *
 * @this AppTree
 */


async function handleClick({
  key,
  keyPath
}) {
  const path = keyPath.reverse(),
        {
    selectedId,
    selected
  } = this.props.store,
        _applyOrder = applyOrder.bind(this);

  if (path[0] === "manual") {
    this.setState({
      rearrangeBoxId: selectedId
    });
  } else if (path[0] === "applyOnce") {
    _applyOrder(selected, key);
  } else if (path[0] === "applyAutomatically") {
    _applyOrder(selected, key, true);
  } else if (key === "reset") {
    _applyOrder(selected, "original");
  } else if (key === "resetAutomatically") {
    _applyOrder(selected, "deactivate");
  } else if (key === "applyReindex") {
    _applyOrder(selected, "reindex");
  }
}
/**
 * Render the order menu.
 *
 * @type React.Element
 */


export default function () {
  const {
    store
  } = this.props,
        {
    selectedId,
    selected
  } = store,
        sortables = store.treeSortables,
        isFolder = selectedId > 0;
  return isFolder ? /*#__PURE__*/React.createElement(Menu, {
    onClick: handleClick.bind(this),
    theme: IS_DARKMODE ? "dark" : "light"
  }, /*#__PURE__*/React.createElement(Item, {
    key: "manual"
  }, i18n("sortByManual", {
    name: textDots(selected.title)
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ItemGroup, {
    title: /*#__PURE__*/React.createElement("span", null, i18n("subfolders"), " (", textDots(selected.title), ")")
  }, !!selected.lastSubOrderBy && /*#__PURE__*/React.createElement(Item, {
    key: "reset"
  }, i18n("resetOrder")), !selected.subOrderAutomatically ? /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyOnce",
    title: i18n("applyOrderOnce")
  }, sortables && createSortables(sortables, selected.lastSubOrderBy, i18n("last"))) : /*#__PURE__*/React.createElement(Item, {
    key: "resetAutomatically"
  }, i18n("deactivateOrderAutomatically")), /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyAutomatically",
    title: i18n("applyOrderAutomatically")
  }, sortables && createSortables(sortables, selected.subOrderAutomatically && selected.lastSubOrderBy, i18n("latest"))), !!selected.lastSubOrderBy && /*#__PURE__*/React.createElement(Item, {
    key: "applyReindex"
  }, i18n("reindexOrder")))) : /*#__PURE__*/React.createElement("span", null);
}
/**
 * Show a rearrange box for the selected folder id.
 *
 * @property {int} id The id of the folder
 * @extends React.Component
 */

let RearrangeBox = (_dec = inject("store"), _dec(_class = observer(_class = class RearrangeBox extends React.Component {
  constructor(_props) {
    super(_props);

    this.handleSelect = parent => {
      const {
        siblingStore
      } = this,
            tree = $.extend(true, [], getSnapshot(parent ? parent.childNodes : this.props.store.tree));
      tree.forEach(n => n.childNodes = []);
      siblingStore.setTree(tree);
      const {
        selected
      } = siblingStore;
      selected && selected.setter(n => n.selected = false); // Reset selection
    };

    this.handleSave = async () => {
      this.setState({
        loading: true
      });

      try {
        const {
          store
        } = this.props,
              {
          id
        } = this.item,
              {
          parentStore,
          siblingStore
        } = this,
              oldItem = store.getTreeItemById(id),
              props = {
          id,
          oldIndex: oldItem.parentArray.indexOf(oldItem),
          parentFromId: oldItem.parentId,
          parentToId: parentStore.selected ? parentStore.selectedId : store.rootId,
          nextId: siblingStore.selectedId || NaN,
          doFinally: false
        }; // Get newIndex

        const parentTo = store.getTreeItemById(props.parentToId),
              newIndexRelative = parentTo ? parentTo.childNodes : store.tree,
              newIndexA = newIndexRelative.filter(({
          id
        }) => id !== oldItem.id).map(({
          id
        }, idx) => id === props.nextId ? "" + idx : null).filter(Boolean).map(i => +i);
        props.newIndex = !isNaN(props.nextId) && newIndexA.length ? newIndexA[0] : newIndexRelative.length; // Do the sorting

        this.props.onSort(props);
      } finally {
        this.setState({
          loading: false
        });
      }
    };

    this.handleNodeInit = itemId => {
      const {
        nextSibling,
        parentArray
      } = this.item = this.parentStore.getTreeItemById(itemId, false),
            id = nextSibling ? nextSibling.id : undefined;
      this.setState({
        nextId: id
      }, () => {
        const tree = $.extend(true, [], getSnapshot(parentArray)),
              {
          siblingStore,
          parentStore
        } = this;
        tree.forEach(n => n.childNodes = []);
        siblingStore.setTree(tree);
        parentStore.getTreeItemById(this.item.id).setter(n => n.$visible = false);
        siblingStore.getTreeItemById(this.item.id).setter(n => n.$visible = false);
        id !== undefined && siblingStore.getTreeItemById(id).setter(n => n.selected = true);
      });
    };

    this.state = {
      nextId: undefined,
      loading: false
    };
    this.parentStore = BasicStore.create({
      staticTree: [createUnorganizedNode()]
    }); // Create sibling store

    this.siblingStore = BasicStore.create({
      staticTree: [createUnorganizedNode()]
    });
  }
  /**
   * Create the sibling tree.
   */


  render() {
    let modalContent, title;
    const selected = this.props.id && this.props.store.getTreeItemById(this.props.id, false);

    if (selected) {
      const selectedId = selected.parentId > 0 ? selected.parentId : "";
      title = /*#__PURE__*/React.createElement(FolderBoxHeader, {
        icon: /*#__PURE__*/React.createElement(DashIcon, {
          name: "sort"
        }),
        folder: selected
      });
      modalContent = /*#__PURE__*/React.createElement(FolderBox, {
        folder: selected,
        header: false
      }, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h3", null, i18n("parent")), /*#__PURE__*/React.createElement(Provider, {
        tree: this.parentStore
      }, /*#__PURE__*/React.createElement(FolderSelector, {
        selected: selectedId,
        nullable: true,
        disabled: "4",
        onSelect: this.handleSelect,
        onNodeInit: (...args) => this.handleNodeInit(this.props.id, ...args)
      })), /*#__PURE__*/React.createElement("h3", null, i18n("beforeThisNode")), /*#__PURE__*/React.createElement(Provider, {
        tree: this.siblingStore
      }, /*#__PURE__*/React.createElement(FolderSelector, {
        fetch: false,
        nullable: true,
        disabled: "4",
        ignoreChildNodes: true
      })), /*#__PURE__*/React.createElement("p", {
        className: "description"
      }, i18n("beforeThisNodeInfo"))));
    }

    return /*#__PURE__*/React.createElement(Modal, {
      visible: !!modalContent,
      title: title,
      onOk: this.handleSave,
      onCancel: this.props.onClose,
      cancelText: i18n("cancel"),
      okText: i18n("save"),
      zIndex: getMediaDialogNextZIndex(),
      confirmLoading: this.state.loading
    }, modalContent);
  }

}) || _class) || _class);
export { RearrangeBox };